import Input from "components/base/Input/Input";

export default Input;
